import { Spinner2Cvna } from '@carvana/ds-icons';
import React, { lazy } from 'react';
import '@carvana/ds-component-loading/styles.css';
import Actions from './components/actions';
import ExampleVisualization from './components/example-visualization';
import PaymentDetails from './components/payment-details';
import useGapCoverageVm from './gap-coverage-vm';
import styles from './gap-coverage.module.css';
import Page from '|/components/carvana-ds/page';

const UnavailableModal = lazy(
  () => import(/* webpackChunkName: "unavailable" */ './components/unavailable-modal')
);

const GapCoverage = () => {
  const {
    gapWaiver,
    loadError,
    isSubmitting,
    handleContinue,
    handleDecline,
    isUnavailableModalOpen,
    handleUnavailableModalClose
  } = useGapCoverageVm();

  if (!gapWaiver) return <Spinner2Cvna />;

  if (!gapWaiver.isAvailable) {
    return (
      <UnavailableModal isOpen={isUnavailableModalOpen} onClose={handleUnavailableModalClose} />
    );
  }

  return (
    <>
      <Page
        title="GAP coverage"
        subtitle="In the event of a total loss from an accident or theft, most insurance payouts do not equal the amount still owed. GAP coverage protects you by covering the remaining amount."
      >
        <div className={styles.content} data-testid="qe-gap-coverage-page">
          <ExampleVisualization />

          <PaymentDetails gapWaiver={gapWaiver} />

          <Actions
            isApplied={gapWaiver.isApplied}
            loadError={loadError}
            isSubmitting={isSubmitting}
            handleContinue={handleContinue}
            handleDecline={handleDecline}
          />
        </div>
      </Page>
    </>
  );
};

export default GapCoverage;
